import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export const startToast = () => {
  return toast.loading("Loading...", {
    icon: true,
    theme: "dark",
    toastId: "operation-toast",
  });
};

export const updateToastSuccess = (message) => {
  toast.update("operation-toast", {
    render: `${message}`,
    type: "success",
    isLoading: false,
    autoClose: 3000,
    icon: "🟢",
  });
};

export const updateToastError = (message) => {
  toast.update("operation-toast", {
    render: `${message}`,
    type: "error",
    isLoading: false,
    autoClose: 5000,
    icon: "❌",
  });
};

export const updateToastWarning = (message) => {
  toast.update("operation-toast", {
    render: `${message}`,
    type: "warning",
    isLoading: false,
    autoClose: 4000,
    icon: "⚠️",
  });
};

export const updateToastDismiss = () => {
  toast.dismiss("operation-toast");
}

export const toastSuccess = (message) => {
  toast.success(message, {
    type: "success",
    icon: "🟢",
    autoClose: 3000,
    isLoading: false,
  })
}

export const toastError = (message) => {
  toast.error(message, {
    type: "error",
    icon: "❌",
    autoClose: 3000,
    isLoading: false,
  })
}